import React, { useState, useEffect, useContext, useRef } from "react";
import api from "../../../../../../services/api";
import { useHistory } from "react-router-dom";
//@ts-ignore
import classnames from "classnames";
import { Empresa } from "../../../../../../entities/Common";
import EmpresaContext from "../../../../../../contexts/Empresa";
import { ApiAccess } from "../../../../../../entities/Security";
// @ts-ignore
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// @ts-ignore
import NotificationAlert from "react-notification-alert";
import SimpleHeader from "../../../../../../components/Headers/SimpleHeader";
//@ts-ignore
import { CopyToClipboard } from "react-copy-to-clipboard";
import ReactBSAlert from "react-bootstrap-sweetalert";

import {
  Row,
  PopoverBody,
  UncontrolledPopover,
  UncontrolledTooltip,
  Button,
  ModalFooter,
  Modal,
  ModalBody,
  ModalHeader,
  Badge,
  ListGroup,
  ListGroupItem,
  NavItem,
  NavLink,
  Input,
  Label,
  Collapse,
  Spinner,
} from "reactstrap";
import AddEquipeFormModal from "./components/AddEquipeFormModal";

interface FBAdsProps {
  fbStatus: boolean;
  connectedPages: any;
  loadPages: () => void;
}

const FacebookAds: React.FC<FBAdsProps> = ({
  fbStatus,
  connectedPages,
  loadPages,
}) => {
  const [showEmailForm, setShowEmalForm] = useState(false);
  const [apiAccess, setApiAccess] = useState<ApiAccess>({} as ApiAccess);
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [showSmsForm, setShowSmsForm] = useState(false);
  const [textCopiar, setTextCopiar] = useState("Copiar token");
  const notificationAlert = useRef<any>();
  const [alert, setAlert] = useState<any>(null);
  // const [fbStatus, setFbStatus] = useState<any>(false);
  // const [connectedPages, setConnectedPages] = useState([]);
  const [tabActive, setTabActive] = useState("emails");
  const [empresa, setEmpresa] = useState({});
  const history = useHistory();

  const [showPagesModal, setShowPagesModal] = useState<boolean>(false);
  const [fetchedPages, setFetchedPages] = useState<any[]>([]);
  const [tempUserToken, setTempUserToken] = useState<string>("");
  const [isSubmittingPages, setIsSubmittingPages] = useState<boolean>(false);
  const [pagesStatus, setPagesStatus] = useState<Record<string, boolean>>({});
  const [expandedPages, setExpandedPages] = useState<Record<string, boolean>>(
    {},
  );
  const [pageForms, setPageForms] = useState<Record<string, any[]>>({});
  const [loadingForms, setLoadingForms] = useState<Record<string, boolean>>({});

  const [showFormsModal, setShowFormsModal] = useState<boolean>(false);
  const [formsModalPage, setFormsModalPage] = useState<any>(null);
  const [metaForms, setMetaForms] = useState<any[]>([]);
  const [isLoadingMetaForms, setIsLoadingMetaForms] = useState<boolean>(false);
  const [isSubmittingForms, setIsSubmittingForms] = useState<boolean>(false);

  const [showManualFormModal, setShowManualFormModal] =
    useState<boolean>(false);
  const [manualFormPage, setManualFormPage] = useState<any>(null);
  const [manualFormName, setManualFormName] = useState<string>("");
  const [manualFormId, setManualFormId] = useState<string>("");
  const [isSubmittingManualForm, setIsSubmittingManualForm] =
    useState<boolean>(false);

  const [isModalFormEquipeOpen, setIsModalFormEquipeOpen] =
    useState<boolean>(false);
  const [formSelecionado, setFormSelecionado] = useState<any>(null);

  async function fetchPageForms(pageId: string) {
    setLoadingForms((prev) => ({ ...prev, [pageId]: true }));
    try {
      const res = await api.get(`/meta/pages/${pageId}/forms`);
      setPageForms((prev) => ({
        ...prev,
        [pageId]: res.data.rows ?? res.data ?? [],
      }));
    } catch (e) {
      setPageForms((prev) => ({ ...prev, [pageId]: [] }));
    } finally {
      setLoadingForms((prev) => ({ ...prev, [pageId]: false }));
    }
  }

  async function togglePageForms(pageId: string) {
    const isExpanding = !expandedPages[pageId];
    setExpandedPages((prev) => ({ ...prev, [pageId]: isExpanding }));

    if (isExpanding && !pageForms[pageId]) {
      await fetchPageForms(pageId);
    }
  }

  async function openFormsModal(page: any) {
    setFormsModalPage(page);
    setShowFormsModal(true);
    setIsLoadingMetaForms(true);
    try {
      // Formulários salvos no banco (fonte de verdade para o fallback)
      const playneeRes = await api.get(`/meta/pages/${page.id}/forms`);
      const savedForms = playneeRes.data.rows ?? playneeRes.data ?? [];
      const playneeIds = new Set(savedForms.map((f: any) => String(f.id)));

      // Tenta buscar os formulários direto no Meta
      let metaRes: any = null;
      try {
        metaRes = await fetch(
          `https://graph.facebook.com/v19.0/${page.id}/leadgen_forms?access_token=${page.access_token}&fields=id,name&limit=1000`,
        ).then((r) => r.json());
      } catch (metaErr) {
        metaRes = null;
      }

      if (metaRes && Array.isArray(metaRes.data)) {
        const forms = metaRes.data.map((f: any) => ({
          ...f,
          selected: playneeIds.has(String(f.id)),
        }));
        setMetaForms(forms);
      } else {
        // Meta falhou → exibe apenas os formulários salvos no banco
        notify(
          "warning",
          "Não foi possível carregar os formulários do Meta. Exibindo os formulários salvos.",
        );
        const forms = savedForms.map((f: any) => ({
          ...f,
          selected: true,
        }));
        setMetaForms(forms);
      }
    } catch (e) {
      notify("danger", "Não foi possível carregar formulários.");
      setShowFormsModal(false);
    } finally {
      setIsLoadingMetaForms(false);
    }
  }

  function toggleFormSelection(formId: string) {
    setMetaForms((prev) =>
      prev.map((f) =>
        String(f.id) === formId ? { ...f, selected: !f.selected } : f,
      ),
    );
  }

  async function submitForms() {
    if (!formsModalPage) return;
    setIsSubmittingForms(true);
    try {
      const selected = metaForms
        .filter((f) => f.selected)
        .map(({ id, name }) => ({ id, name }));
      await api.post(`/meta/pages/${formsModalPage.id}/forms/sync`, {
        forms: selected,
      });
      notify("success", "Formulários sincronizados.");
      setShowFormsModal(false);
      setPageForms((prev) => ({ ...prev, [formsModalPage.id]: selected }));
    } catch (e) {
      notify("danger", "Não foi possível salvar formulários.");
    } finally {
      setIsSubmittingForms(false);
    }
  }

  async function openManualFormModal(page: any) {
    setManualFormPage(page);
    setManualFormName("");
    setManualFormId("");
    setShowManualFormModal(true);
  }

  async function submitManualForm() {
    if (!manualFormPage || !manualFormName || !manualFormId) {
      notify("warning", "Preencha todos os campos.");
      return;
    }
    setIsSubmittingManualForm(true);
    try {
      // Get current forms for this page to avoid overwriting
      const currentForms = pageForms[manualFormPage.id] || [];
      const newForm = { id: manualFormId, name: manualFormName };

      // Update with the new manual form
      const updatedForms = [...currentForms, newForm];

      await api.post(`/meta/pages/${manualFormPage.id}/forms/sync`, {
        forms: updatedForms,
      });

      notify("success", "Formulário adicionado com sucesso.");
      setShowManualFormModal(false);
      setPageForms((prev) => ({ ...prev, [manualFormPage.id]: updatedForms }));
    } catch (e) {
      notify("danger", "Não foi possível adicionar o formulário.");
    } finally {
      setIsSubmittingManualForm(false);
    }
  }

  async function removeForm(pageId: string, formId: string) {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Deseja realmente remover este formulário?"
        onConfirm={async () => {
          try {
            const currentForms = pageForms[pageId] || [];
            const updatedForms = currentForms.filter(
              (f: any) => String(f.id) !== String(formId),
            );

            await api.post(`/meta/pages/${pageId}/forms/sync`, {
              forms: updatedForms,
            });

            notify("success", "Formulário removido.");
            setPageForms((prev) => ({ ...prev, [pageId]: updatedForms }));
            setAlert(null);
          } catch (e) {
            notify("danger", "Não foi possível remover o formulário.");
            setAlert(null);
          }
        }}
        onCancel={() => setAlert(null)}
        showCancel
        confirmBtnBsStyle="danger"
        confirmBtnText="Sim, remover"
        cancelBtnBsStyle="secondary"
        cancelBtnText="Cancelar"
        focusCancelBtn
      />,
    );
  }

  useEffect(() => {
    if (empresaSelecionada && empresaSelecionada.id) loadApiAccess();
  }, []);

  useEffect(() => {
    if (connectedPages && connectedPages.length > 0) {
      connectedPages.forEach(async (page: any) => {
        try {
          const res = await fetch(
            `https://graph.facebook.com/v19.0/me?access_token=${page.access_token}`,
          );
          if (res.ok) {
            setPagesStatus((prev) => ({ ...prev, [page.id]: true }));
          } else {
            setPagesStatus((prev) => ({ ...prev, [page.id]: false }));
          }
        } catch (e) {
          setPagesStatus((prev) => ({ ...prev, [page.id]: false }));
        }
      });

      // Carrega e exibe os formulários salvos no banco de cada página conectada
      connectedPages.forEach((page: any) => {
        setExpandedPages((prev) => ({ ...prev, [page.id]: true }));
        fetchPageForms(page.id);
      });
    }
  }, [connectedPages]);

  useEffect(() => {
    console.log({
      TOKEN_FB: new URLSearchParams(window.location.search).get("code"),
    });
  }, []);

  function onEmpresaChange(empresa: any) {
    setEmpresa(empresa ? empresa : {});
  }

  async function onFacebookResponse({ accessToken }: any) {
    if (!accessToken) {
      notify("danger", "Não conseguimos concluir a operação");
      return;
    }
    try {
      const data = await getMyPages(accessToken);

      const pageIds = data ? data.map((p: any) => p.id) : [];
      let conflictingIds: string[] = [];
      if (pageIds.length > 0 && empresaSelecionada?.id) {
        try {
          const conflictRes = await api.post(
            `/common/empresas/${empresaSelecionada.id}/checkfacebookpages`,
            { pageIds },
          );
          if (conflictRes.data) {
            conflictingIds = conflictRes.data;
          }
        } catch (e) {
          console.error("error checking conflicts", e);
        }
      }

      const pages = data
        ? data.map((p: any) => ({
            ...p,
            selected: false,
            isConflicting: conflictingIds.includes(p.id),
          }))
        : [];
      setFetchedPages(pages);
      setTempUserToken(accessToken);
      setShowPagesModal(true);
    } catch (error) {
      console.error(error);
      notify("danger", "Não foi possível concluir a operação.");
    }
  }

  async function submitPages() {
    setIsSubmittingPages(true);
    try {
      await api.patch(
        `common/empresas/${empresaSelecionada?.id}/updatefacebooktoken`,
        {
          token: tempUserToken,
          pages: fetchedPages,
        },
      );
      notify("success", "Operação realizada");
      setShowPagesModal(false);
      loadPages();
    } catch (error) {
      console.error(error);
      notify("danger", "Não foi possível concluir a operação.");
    } finally {
      setIsSubmittingPages(false);
    }
  }

  const togglePageSelection = (pageId: string) => {
    setFetchedPages((prev) =>
      prev.map((p) => (p.id === pageId ? { ...p, selected: !p.selected } : p)),
    );
  };

  async function getMyPages(accessToken: any) {
    try {
      const data = await fetch(
        `https://graph.facebook.com/me/accounts?access_token=${accessToken}&fields=access_token,id,%20name&limit=10000`,
      ).then((e) => e.json().then((r) => r.data));

      for (const page of data) {
        fetch(
          `https://graph.facebook.com/${page.id}/subscribed_apps?subscribed_fields=leadgen&access_token=${page.access_token}`,
          {
            method: "POST",
          },
        )
          .then((e) => console.log(`listen ${page.name}`))
          .catch(console.error);
      }

      return data;
    } catch (error) {
      console.log(error);
    }
  }
  function hanleNewEmail(e: React.MouseEvent) {
    e.preventDefault();
    setShowEmalForm(true);
  }

  function handleNewSms(e: React.MouseEvent) {
    e.preventDefault();
    setShowSmsForm(true);
  }

  async function loadApiAccess() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/api-access`,
      );
      setApiAccess(response?.data);
    } catch (error) {
      console.log(error);
      notify("danger", "Não foi possível carregar empresa");
    }
  }

  function notify(type: string, msg: string) {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7,
    };
    if (notificationAlert) notificationAlert.current.notificationAlert(options);
  }

  const CustomNavItem = ({ children, disabled, name }: any) => {
    return (
      <>
        <NavItem>
          <NavLink
            href="#"
            role="tab"
            className={classnames("mb-sm-3 mb-md-0 mt-2", {
              active: tabActive === name,
            })}
            onClick={() => setTabActive(name)}
            disabled={disabled}
          >
            {children}
          </NavLink>
        </NavItem>
      </>
    );
  };

  const ButtonHelp = () => (
    <>
      <Button
        color="link"
        id="tooltip-99882211"
        outline
        size="sm"
        onClick={() =>
          window.open(
            "https://ajuda.playnee.com/artigos/como-integrar-minha-conta-do-facebook-ads-ao-playnee",
            "_blank",
          )
        }
        type="button"
      >
        ?
      </Button>
    </>
  );

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <Row>
        <div
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <h2>Facebook Ads</h2>
          <ButtonHelp />
        </div>
      </Row>
      <Row className="pt-5 mb-5">
        <div
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <FacebookLogin
            appId="735161440956284"
            autoLoad={false}
            icon={<i className="fab fa-facebook mr-4"></i>}
            size="small"
            version="3.1"
            onFailure={(e: any) => {
              console.log({ onFailure: e });
              notify("danger", "Falhou ao conectar com o Facebook.");
            }}
            textButton="Login com Facebook"
            // whatsapp perm
            scope="pages_show_list,leads_retrieval,pages_read_engagement,ads_management,pages_manage_ads,pages_manage_metadata,business_management"
            // whatsapp_business_management,whatsapp_business_messaging
            // prod branch
            // scope="pages_show_list,instagram_basic,pages_read_engagement,ads_management,pages_manage_ads"
            // dev branch
            // scope="ads_management,leads_retrieval, pages_show_list,pages_read_engagement,pages_manage_ads"
            fields="public_profile"
            render={(renderProps: any) => (
              <div style={{ justifyContent: "center", display: "flex" }}>
                <Button
                  size="md"
                  className="btn-icon"
                  color="facebook"
                  type="button"
                  onClick={renderProps.onClick}
                >
                  <span className="btn-inner--icon">
                    <i className="fab fa-facebook" />
                  </span>
                  <span className="btn-inner--text">
                    Conceder acesso ao Facebook
                  </span>
                </Button>
                <Button
                  color="secondary"
                  id="tooltip-998822"
                  outline
                  size="sm"
                  type="button"
                >
                  ?
                </Button>
                <UncontrolledPopover placement="top" target="tooltip-998822">
                  <PopoverBody>
                    Precisamos que você autorize o Playnee a acessar sua conta
                    do Facebook.
                    <br />
                    Isso permite que nossas integrações com a plataforma
                    funcionem sem problemas.
                    <br />
                    Se deseja usar a <b>captação de oportunidades</b> e/ou{" "}
                    <b>publicações automáticas</b> no Facebook, você precisa
                    conceder este acesso.
                  </PopoverBody>
                </UncontrolledPopover>
                <div className="d-flex align-items-center">
                  <Badge color={fbStatus ? "success" : "danger"}>
                    {fbStatus ? "Conectado" : "Não conectado"}
                  </Badge>
                </div>
              </div>
            )}
            callback={(response: any) => {
              console.log({ facebookLoginResponse: response });
              onFacebookResponse(response);
            }}
          />
        </div>
      </Row>

      {connectedPages && connectedPages.length > 0 && (
        <ListGroup className="list mt-4" flush>
          <h3>Páginas Conectadas</h3>
          {connectedPages.map((element: any) => {
            const isFailed = pagesStatus[element.id] === false;
            const isExpanded = !!expandedPages[element.id];
            const forms = pageForms[element.id] ?? [];
            const isLoading = !!loadingForms[element.id];
            return (
              <ListGroupItem
                color={isFailed ? "danger" : undefined}
                className="px-3 py-2"
                style={{ display: "block", borderRadius: 6, marginBottom: 4 }}
                key={element.id}
              >
                {/* Page header row */}
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => togglePageForms(element.id)}
                >
                  <div className="d-flex align-items-center">
                    <i
                      className={`fas fa-chevron-${isExpanded ? "up" : "down"} mr-2 text-muted`}
                      style={{ fontSize: 11, width: 12 }}
                    />
                    <span className="font-weight-bold" style={{ fontSize: 15 }}>
                      {element.name}
                    </span>
                    {isFailed && (
                      <>
                        <i
                          className="fas fa-exclamation-circle ml-2 text-danger"
                          id={`tooltip-page-${element.id}`}
                          style={{ cursor: "pointer" }}
                        />
                        <UncontrolledTooltip
                          placement="top"
                          target={`tooltip-page-${element.id}`}
                        >
                          A conexão com esta página foi perdida. Reconecte para
                          continuar.
                        </UncontrolledTooltip>
                      </>
                    )}
                  </div>
                </div>

                {/* Collapsible forms section */}
                <Collapse isOpen={isExpanded}>
                  <div
                    className="mt-2"
                    style={{ borderTop: "1px solid #e9ecef" }}
                  >
                    {isLoading ? (
                      <div className="text-center py-2">
                        <Spinner size="sm" />
                      </div>
                    ) : forms.length === 0 ? (
                      <p
                        className="text-muted text-center mb-2"
                        style={{ fontSize: 13 }}
                      >
                        Nenhum formulário ativo. Clique em Sincronizar para
                        importar.
                      </p>
                    ) : (
                      <div className="mb-2">
                        {forms.map((form: any) => (
                          <div
                            key={form.id}
                            className="d-flex align-items-center justify-content-between py-2 px-2"
                            style={{
                              fontSize: 13,
                              borderBottom: "1px solid #f0f0f0",
                              minHeight: 40,
                            }}
                          >
                            <span>
                              <i
                                className="fas fa-wpforms mr-2 text-muted"
                                style={{ fontSize: 11 }}
                              />
                              {form.name || form.id}
                            </span>
                            <div className="d-flex align-items-center">
                              <Button
                                size="sm"
                                color="primary"
                                className="btn-sm py-0 mr-2"
                                style={{ fontSize: 11 }}
                                onClick={() => {
                                  setFormSelecionado(form);
                                  setIsModalFormEquipeOpen(true);
                                }}
                              >
                                Editar Equipes
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                className="btn-sm py-0"
                                style={{ fontSize: 11, padding: "2px 6px" }}
                                onClick={() => removeForm(element.id, form.id)}
                              >
                                <i className="fas fa-trash" />
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <div className="text-center mt-2 d-flex justify-content-center">
                      <Button
                        size="sm"
                        color="secondary"
                        onClick={() => openFormsModal(element)}
                        className="mr-2"
                      >
                        <i className="fas fa-sync-alt mr-1" />
                        Sincronizar Formulários
                      </Button>
                      <Button
                        size="sm"
                        color="info"
                        onClick={() => openManualFormModal(element)}
                      >
                        <i className="fas fa-plus mr-1" />
                        Adicionar Manualmente
                      </Button>
                    </div>
                  </div>
                </Collapse>
              </ListGroupItem>
            );
          })}
        </ListGroup>
      )}

      <AddEquipeFormModal
        show={isModalFormEquipeOpen}
        close={() => {
          setIsModalFormEquipeOpen(false);
          setFormSelecionado(null);
        }}
        formId={formSelecionado?.id || ""}
        formName={formSelecionado?.name}
      />

      <Modal
        isOpen={showFormsModal}
        toggle={() => !isSubmittingForms && setShowFormsModal(false)}
      >
        <ModalHeader
          toggle={() => !isSubmittingForms && setShowFormsModal(false)}
        >
          Formulários {formsModalPage?.name}
        </ModalHeader>
        <ModalBody className="pt-1 pb-0">
          <p className="mb-2">
            Selecione os formulários do Meta que deseja ativar no Playnee. Os
            desmarcados serão removidos.
          </p>
          {isLoadingMetaForms ? (
            <div className="text-center py-3">
              <Spinner />
            </div>
          ) : metaForms.length === 0 ? (
            <p className="text-muted text-center">
              Nenhum formulário encontrado no Meta.
            </p>
          ) : (
            <ListGroup className="mb-0">
              {metaForms.map((form) => (
                <ListGroupItem
                  key={form.id}
                  className="d-flex justify-content-between align-items-center"
                >
                  <span>{form.name || form.id}</span>
                  <Input
                    type="checkbox"
                    checked={form.selected}
                    onChange={() => toggleFormSelection(String(form.id))}
                    style={{ position: "relative", marginLeft: "10px" }}
                  />
                </ListGroupItem>
              ))}
            </ListGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowFormsModal(false)}
            disabled={isSubmittingForms}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={submitForms}
            disabled={isSubmittingForms || isLoadingMetaForms}
          >
            {isSubmittingForms ? "Salvando..." : "Salvar"}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={showManualFormModal}
        toggle={() => !isSubmittingManualForm && setShowManualFormModal(false)}
      >
        <ModalHeader
          toggle={() =>
            !isSubmittingManualForm && setShowManualFormModal(false)
          }
        >
          Adicionar Formulário Manualmente - {manualFormPage?.name}
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label className="form-control-label">Nome do Formulário</label>
            <Input
              type="text"
              placeholder="Ex: Lead Ad Form"
              value={manualFormName}
              onChange={(e) => setManualFormName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-control-label">ID do Formulário</label>
            <Input
              type="text"
              placeholder="Ex: 1234567890"
              value={manualFormId}
              onChange={(e) => setManualFormId(e.target.value)}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowManualFormModal(false)}
            disabled={isSubmittingManualForm}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={submitManualForm}
            disabled={
              isSubmittingManualForm || !manualFormName || !manualFormId
            }
          >
            {isSubmittingManualForm ? "Adicionando..." : "Adicionar"}
          </Button>
        </ModalFooter>{" "}
      </Modal>

      <Modal
        isOpen={showPagesModal}
        toggle={() => setShowPagesModal(!showPagesModal)}
      >
        <ModalHeader toggle={() => setShowPagesModal(!showPagesModal)}>
          Selecione as Páginas
        </ModalHeader>
        <ModalBody className="pt-1 pb-0">
          <p className="mb-2">
            Escolha quais páginas você deseja conectar. As não selecionadas
            ficarão inativas.
          </p>
          <ListGroup className="mb-0">
            {fetchedPages.map((page) => (
              <ListGroupItem
                key={page.id}
                className="d-flex justify-content-between align-items-center"
              >
                <span>
                  {page.name}
                  {page.isConflicting && (
                    <Badge color="secondary" className="ml-2">
                      Conectada em outra empresa
                    </Badge>
                  )}
                </span>
                <Input
                  type="checkbox"
                  checked={page.selected}
                  onChange={() => togglePageSelection(page.id)}
                  style={{ position: "relative", marginLeft: "10px" }}
                />
              </ListGroupItem>
            ))}
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowPagesModal(false)}>
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={submitPages}
            disabled={isSubmittingPages}
          >
            {isSubmittingPages ? "Salvando..." : "Salvar Páginas"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FacebookAds;
